export default __webpack_public_path__ + "static/media/gyroX.b3c29ead.svg";